/* eslint-disable prefer-destructuring */
/* eslint-disable dot-notation */
/* eslint-disable camelcase */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root' // ✅ indispensable pour standalone
})
export class AuthService {

  public token: string = '';
  private headers: HttpHeaders;
  private readonly apiUrl = environment.apiUrl;

  private loggedIn = false;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Access-Control-Allow-Origin', '*');
    this.headers.append('Access-Control-Allow-Headers', 'Origin, Authorization, Content-Type, Accept');

    const currentUser = JSON.parse(<string>localStorage.getItem('user'));
    this.token = currentUser && currentUser.token;
  }

  login(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/authenticate`, body, {headers: this.headers})
      .pipe(
        map((response: any) => {
          this.token = response['accessToken'];
          if (this.token) {

            this.loggedIn = true;

            localStorage.setItem(
              'user',
              JSON.stringify({ token: this.token }),
            );
            this.router.navigate(['/affaires']);
          }
          return response;
        }),
      );
  }

  register(form: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/register`, form, { headers: this.headers })
      .pipe(
        map((response: any) => {
          this.token = response['accessToken'];
          if (this.token) {

            this.loggedIn = true;

            localStorage.setItem(
              'user',
              JSON.stringify({ token: this.token }),
            );
            this.router.navigate(['/affaires']);
          }
          return response;
        }),
      );
  }

  sendResetLink(form: FormGroup): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-reset-link`, form.value, { headers: this.headers });
  }

  resetPassword(form: FormGroup): Observable<any> {
    return this.http.post(`${this.apiUrl}/change-password`, form.value, { headers: this.headers });
  }

  logout(): void {
    this.token = '';
    this.loggedIn = false;
    localStorage.removeItem('user');
  }

  getToken(): string {
    return this.token;
  }

  getUserInfos(token: string): any {
    const decoded = this.getDecodedToken(token);

    return decoded;
  }

  isTokenExpired(token: string): boolean {
    const date = this.getTokenExpirationDate(token);

    if (!date)
      return true;

    return date.valueOf() <= new Date().valueOf();
  }


  private getTokenExpirationDate(token: string): Date | null {
    const decoded = jwtDecode(token);

    if (decoded.exp === undefined)
      return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  private getDecodedToken(token: string) {

    if(!token) return "";

    return jwtDecode(token);
  }

  getCurrentUserInfo() {
    return this.getUserInfos(this.getToken());
  }

  isAdmin(): boolean {

    if(!this.token) return false

    return this.getCurrentUserInfo().roles.includes('administrator');
  }

  isLoggedIn() {
    return this.loggedIn;
  }
}
